import { connectHits } from 'instantsearch.js/es/connectors';

const renderRecipeCard = (item, widgetParams) => {
	const linkClass = `group/card${widgetParams.isSlider ? ' w-80 h-auto swiper-slide' : ''}`;

	const sliderRecipeBadge = widgetParams.isSlider
		? '<span class="absolute bottom-0 py-3.5 px-5 bg-orange text-xs font-semibold tracking-wider uppercase whitespace-nowrap">Recipe</span>'
		: '';

	const imageBlock = item.image
		? [
				'<div class="relative mb-4 overflow-hidden after:block after:pb-[120%]">',
				`<img src="${item.image}" class="absolute w-full h-full object-cover transition-transform group-hover/card:scale-105" alt="${item.image_alt}">`,
				sliderRecipeBadge,
				'</div>',
			].join('')
		: '';

	const categoryBlock =
		item.taxonomies.recipe_cat.length > 0
			? `<span class="block mb-2.5 text-orange font-gotham text-xs font-bold tracking-widest leading-relaxed uppercase">${item.taxonomies.recipe_cat[0]}</span>`
			: '';

	const prepPart = item.prep ? `${item.prep}` : '';
	const servesPart = item.serves ? `${item.prep ? ' &nbsp;&bull;&nbsp; ' : ''}Serves ${item.serves}` : '';
	const metaBlock = `<div class="mb-6 font-sans">${prepPart}${servesPart}</div>`;

	const viewSpan =
		'<span class="flex items-center text-orange font-gotham text-xs font-bold tracking-widest uppercase transition-colors group-hover/card:text-black group/text-btn" role="button" tabindex="0">View</span>';

	return [
		`<a href="${item.url}" class="${linkClass}">`,
		imageBlock,
		categoryBlock,
		`<h2 class="mb-4 text-3xl">${item.title}</h2>`,
		metaBlock,
		viewSpan,
		'</a>',
	].join('');
};

// create the render function
const renderHits = renderOptions => {
	const { hits, widgetParams } = renderOptions;

	if (hits.length === 0) return;

	widgetParams.container.innerHTML = hits.map(item => renderRecipeCard(item, widgetParams)).join('');
};

// create the custom widget
const customHits = connectHits(renderHits);

export default customHits;
